var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91 81",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.284 19.519H28.276c-1.427 0-2.364 1.237-2.364 2.428v35.83c0 1.466 1.204 2.703 2.364 2.703h33.003c1.427 0 2.363-1.237 2.363-2.703v-30.24H56.06v-8.064l.223.046h0zm-.937 30.974h-21.14v-4.124h21.14v4.124zm0-7.56h-21.14v-4.124h21.14v4.124zm0-7.789h-21.14V31.02h21.14v4.124zM67.433 0H22.567L0 40l22.567 40h44.867L90 40 67.433 0zm-5.932 64.376H28.498c-3.568 0-6.422-2.932-6.422-6.598v-35.83c0-3.666 2.854-6.598 6.422-6.598h29.926l9.5 9.76v32.669c0 3.666-2.854 6.598-6.422 6.598z",
    fill: "#0078d7",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageFiles);
export default __webpack_public_path__ + "static/media/storage-files.d063c686aad03f9e992dfe88959b4124.svg";
export { ForwardRef as ReactComponent };